import { useEffect, useState } from "react";
import { listFolder } from "../lib/storage";

/**
 * Fetch every image in a Storage folder.
 * Returns { images, loading, error }.
 * Images have the shape { name, url, caption }.
 */
export default function useCollectionImages(folder) {
  const [state, setState] = useState({ images: [], loading: true, error: null });

  useEffect(() => {
    if (!folder) {
      setState({ images: [], loading: false, error: null });
      return;
    }
    let alive = true;
    setState({ images: [], loading: true, error: null });
    listFolder(folder)
      .then((images) => alive && setState({ images, loading: false, error: null }))
      .catch((error) => alive && setState({ images: [], loading: false, error }));
    return () => {
      alive = false;
    };
  }, [folder]);

  return state;
}